import { LottieHook, useLottie } from '../../Lottie'
import ConfettiLottie from './lottie.json'

export function useConfetti(): LottieHook {
  return useLottie(ConfettiLottie)
}
